import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const b2cPolicies = {
  names: {
    signUpSignIn: "b2c_1_susi_reset_v2",
    editProfile: "b2c_1_edit_profile_v2"
  },
  authorities: {
    signUpSignIn: {
      authority: "https://login.microsoftonline.com/e0b220ce-5735-4468-91df-05cae5ff1fdc",
    },
    editProfile: {
      authority: "https://login.microsoftonline.com/e0b220ce-5735-4468-91df-05cae5ff1fdc"
    }
  },
  authorityDomain: "login.microsoftonline.com"
};


export const msalConfig: Configuration = {
  auth: {
    clientId: '69f1b765-89d1-4423-8c68-bb7fb878c253',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (logLevel, message, containsPii) => {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}


export const protectedResources = {
  todoListApi: {
    endpoint: "/management",
    scopes: ["https://login.microsoftonline.com/api/tasks.read"],
  },
}
export const loginRequest = {
  scopes: []
};
